"use strict";
angular.module("fusionVersionTimeModule", [])
    .controller('fusionVersionTimeCtrl', ['$scope', '$state', '$stateParams', '$element', '$controller', '$compile', '$q', '$templateRequest', 'trsHttpService', '$location',
        function ($scope, $state, $stateParams, $element, $controller, $compile, $q, $templateRequest, trsHttpService, $location) {
            var pagesInfo = {};
            initStatus();

            function initStatus() {
                $scope.data = {
                    navs: [],
                    getObversionId: [],
                };
                getChannel();
                $scope.status = {
                    firstEnter: true
                };
            }
            /**
             * [getChannel description] 获取关联渠道
             * @return {[type]} [description]
             */
            function geRelatedversion(MetaDataId, num) {
                var deffer = $q.defer()
                var params = {
                    serviceid: "mlf_fusionmyrelease",
                    methodname: "getObjversionByDoc",
                    METADATAID: MetaDataId,
                    VersionNum: num
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function (data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }
            /**
             * [getChannel description] 获取关联渠道
             * @return {[type]} [description]
             */
            function getChannel() {
                $scope.data.navs = [{
                    MEDIANAME: "基础稿",
                    MEDIATYPE: "-1",
                    routerName: "editingCenterIwoPersonalVersionTime",
                    iwoobjectversionid: $stateParams.iwoobjectversionid
                }];
                geRelatedversion($stateParams.metadataid, $stateParams.versionum).then(function (bingdingData) {
                    angular.forEach(bingdingData, function (value, key) {
                        if (key == "app") {
                            $scope.data.navs.push({
                                MEDIANAME: '客户端',
                                virtualDocId: value.virtualDocId,
                                routerName: "editingCenterAppPersonalVersionTime",
                                value: 'app'
                            });
                        } else if (key == "web") {
                            $scope.data.navs.push({
                                MEDIANAME: '网站',
                                virtualDocId: value.virtualDocId,
                                routerName: "editingCenterWebsitePersonalVersionTime",
                                value: 'web'
                            });
                        } else if (key == "paper") {
                            $scope.data.navs.push({
                                MEDIANAME: '纸媒',
                                virtualDocId: value.virtualDocId,
                                routerName: "editingCenterPaperPersonalVersionTime",
                                value: 'paper'
                            });
                        } else if (key == "wechat") {
                            $scope.data.navs.push({
                                MEDIANAME: '微信',
                                virtualDocId: value.virtualDocId,
                                routerName: "editingCenterWeixinPersonalVersionTime",
                                value: 'weixin'
                            });
                        } else if (key == "weibo") {
                            $scope.data.navs.push({
                                MEDIANAME: '微博',
                                virtualDocId: value.virtualDocId,
                                routerName: "editingCenterWeixinPersonalVersionTime",
                                value: 'weibo'
                            });
                        }
                    });
                    selectNav($scope.data.navs[0]);
                });
            }

            /**
             * [selectNav description] 选择导航
             * @param  {[type]} nav [description] 当前导航数据
             * @return {[type]}     [description]
             */
            function selectNav(nav) {
                !$scope.status.firstEnter ? destroyController() : $scope.status.firstEnter = !$scope.status.firstEnter;
                $scope.data.selectedNav = nav;
                var navInfo = $state.get(nav.routerName).views[""]; //路由模板
                getTemplate(navInfo.templateUrl, nav.routerName).then(function ($template) {
                    var controller = {};
                    controller.$scope = $scope.$new();
                    controller.$element = $template;
                    $controller(navInfo.controller, controller);
                    $template = $compile($template)(controller.$scope);
                    $element.find(".main").html($template);
                    $scope.data.selectedNav.controller = controller; //prev
                });
            }

            /**
             * [selectNav description] 选择导航
             * @type {[type]}
             */
            $scope.selectNav = function (nav) {
                selectNav(nav);
            };

            /**
             * [destroyController description] 销毁控制器
             * @return {[type]} [description]
             */
            function destroyController() {
                $scope.data.selectedNav.controller.$scope.$destroy();
            }

            /**
             * [getTemplate description] 获取模板
             * @param {string} [templateUrl] [description] 模板地址
             * @param {string} [pageName] [description] 模板名称
             * @return {[type]} [description]
             */
            function getTemplate(templateUrl, pageName) {
                var deffer = $q.defer();
                if (!!pagesInfo[pageName]) {
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                    return deffer.promise;
                }
                $templateRequest(templateUrl).then(function (template) {
                    var $dom = $(template);
                    pagesInfo[pageName] = {
                        $template: $dom
                    };
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                });
                return deffer.promise;
            }
        }
    ]);